import { Link } from '@tanstack/react-router';
import { Coins } from 'lucide-react';
import { useAuth } from '@/contexts/auth-context';
import { useMyBalance } from './use-rewards';

// Compact token-balance pill for the header. Signed-in only; links to the
// full My Rewards page. (Redeeming tokens isn't available yet — display only.)
export function TokenBalance() {
  const { isAuthenticated } = useAuth();
  const { data } = useMyBalance(isAuthenticated);

  if (!isAuthenticated) return null;

  const tokens = data?.tokenBalance.balance ?? 0;

  return (
    <Link
      to="/rewards"
      aria-label="Your token balance"
      className="flex h-10 items-center gap-1.5 rounded-full border border-border/60 bg-card/60 px-3 text-sm font-semibold text-foreground transition-colors hover:bg-accent/50"
    >
      <Coins className="h-4 w-4 text-amber-500" />
      {tokens.toLocaleString()}
    </Link>
  );
}
